<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>


<section>
  <div class="dta_title mar-tb-20 pad-lr-30 col-md-6">Vendors With Packages : Total (Monthly) </div>

  <div class="row no-mar-lr">
    <div class="col-md-10 mar-lft-20">
      <table class="table table-white table-bordered">
        <thead class="greyBg">
          <tr>
            <th scope="col">Supplier</th>
            <th scope="col">Supplier Name</th>
            <th scope="col">Location</th>
            <th scope="col">Sum Order of No Packaging</th>
            <th scope="col">Sum of Total Order Quantity</th>
            <th scope="col">Missing %</th>
            <th scope="col">Total Box Count</th>
            <th scope="col">Total Order m3</th>
            <th scope="col">Total KG</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>B070</td>
            <td class="hasLink" routerLink="/poSubTotal">Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
          <tr>
            <td>B070</td>
            <td>Bosch 77 Dept of Power</td>
            <td>CC Yokohama</td>
            <td>38</td>
            <td>2339</td>
            <td>1.62%</td>
            <td>68</td>
            <td>1.38</td>
            <td>277.90</td>
          </tr>
        </tbody>
        <tfoot class="greyBg">
          <th>Total</th>
          <th></th>
          <th></th>
          <th>655</th>
          <th>42392</th>
          <th>1.55%</th>
          <th>1128</th>
          <th>52.02</th>
          <th>6766.17</th>

        </tfoot>
      </table>
    </div>
  </div>
</section>